import _ from 'lodash';
import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  loading,
  login,
  logout,
  changeGroup,
  clearToken,
  refreshToken,
  me,
} from './actions';

export const initialState = {
  loading: false,
  user: null,
  token: null,
  error: null,
  myGroups: [],
  currentGroup: null,
};

export const reducer = handleActions(
  {
    [loading]: {
      next: state => update(state, { loading: { $set: true } }),
    },

    [login]: {
      next: (state, { payload }) =>
        update(state, {
          loading: { $set: false },
          token: { $set: payload.token },
          error: { $set: null },
        }),
      throw: state =>
        update(state, {
          loading: { $set: false },
          token: { $set: null },
          error: { $set: null },
        }),
    },

    [me]: {
      next: (state, { payload }) =>
        update(state, {
          loading: { $set: false },
          user: {
            $set: _.pick(payload, ['_id', 'fullname', 'email', 'phone']),
          },
          token: { $set: payload.token },
          error: { $set: null },
          myGroups: { $set: payload.groups },
          currentGroup: {
            $set: (payload.groups || []).find(it => it._id === payload.currentGroup),
          },
        }),
      throw: state =>
        update(state, {
          loading: { $set: false },
          user: { $set: null },
          token: { $set: null },
          error: { $set: null },
          myGroups: { $set: null },
          currentGroup: { $set: null },
        }),
    },

    [logout]: {
      next: state => {
        window.localStorage.clear();

        return update(state, {
          loading: { $set: false },
          user: { $set: null },
          token: { $set: null },
          error: { $set: null },
        });
      },
      throw: state =>
        update(state, {
          loading: { $set: false },
          user: { $set: null },
          token: { $set: null },
          error: { $set: null },
        }),
    },

    [changeGroup]: {
      next: (state, { payload }) =>
        update(state, {
          loading: { $set: false },
          token: { $set: payload.token },
          currentGroup: {
            $set: (state.myGroups || []).find(it => it._id === payload.group),
          },
        }),
    },

    [refreshToken]: {
      next: (state, { payload }) =>
        update(state, {
          token: { $set: payload.token },
          error: { $set: null },
        }),
    },

    [clearToken]: {
      next: state => {
        return update(state, {
          loading: { $set: false },
          user: { $set: null },
          token: { $set: null },
          error: { $set: null },
        });
      },
    },
  },

  _.cloneDeep(initialState)
);

export default reducer;
